import { useState } from 'react';

const idempotent = v => v;
const alwaysPass = v => false;

export const useFormField = (
  initialValue,
  validator,
  labelizer,
  delabelizer,
) => {
  const finalLabelizer =
    typeof labelizer === 'function' ? labelizer : idempotent;
  const finalDelabelizer =
    typeof delabelizer === 'function' ? delabelizer : idempotent;
  const finalValidator =
    typeof validator === 'function' ? validator : alwaysPass;

  const [value, internalSetter] = useState({
    value: initialValue,
    label: finalLabelizer(initialValue),
    error: finalValidator(initialValue),
    invalid: finalValidator(initialValue),
  });

  const setValue = v => {
    let finalValue = v;

    if (
      v &&
      v.target &&
      v.target.value !== null &&
      v.target.value !== undefined
    ) {
      finalValue = v.target.value;
    }
    const validation = finalValidator(finalValue);
    const error = validation ? validation : false;
    internalSetter({
      value: finalDelabelizer(finalValue),
      error,
      label: finalLabelizer(finalDelabelizer(finalValue)),
      invalid: error,
    });
  };

  const formValue = [value, setValue];

  return formValue;
};
